// extracted by mini-css-extract-plugin
module.exports = {"defaulIcon":"infoitem_defaulIcon__2XUjF","valueCol":"infoitem_valueCol__1Upvz"};